import Swiper, { Autoplay, Pagination, Navigation } from 'swiper'

Swiper.use([Autoplay, Pagination, Navigation])

export const ProductListSlider = (target: Element) => {
  const el = {
    swiper: target,
  }

  const method = {
    init: () => {
      // @ts-ignore
      new Swiper(el.swiper, {
        direction: 'horizontal',
        wrapperClass: 'product-slider__wrapper',
        slideClass: 'product-card',
        loop: false,
        grabCursor: true,
        autoHeight: false,
        spaceBetween: 30,
        slidesPerView: 4,
        pagination: {
          el: '.product-list-slider__pagination',
          bulletClass: 'product-images-slider__bullet',
          bulletActiveClass: 'product-images-slider__bullet--active',
          clickable: true,
          renderBullet: (_, className) => {
            return `<button type="button" class="${className}"></button>`
          },
        },
        navigation: {
          nextEl: '.product-images-slider__button--next',
          prevEl: '.product-images-slider__button--prev',
        },
        speed: 600,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 30
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          // when window width is >= 480px
          1000: {
            slidesPerView: 4,
            spaceBetween: 30
          },
          // when window width is >= 640px
          1200: {
            slidesPerView: 4,
            spaceBetween: 30
          }
        }
      })
    },
  }
  method.init()
}
